/**
 * Welfare Filing fetch actions
 */
export const WELFARE_FILINGS_FETCHED = 'WELFARE_FILINGS_FETCHED';
export function welfareFilingsFetched(welfareFilingsReport) {
  return {
    type: WELFARE_FILINGS_FETCHED,
    welfareFilingsReport: welfareFilingsReport,
  };
}
export const WELFARE_FILINGS_REQUEST_STARTED = 'WELFARE_FILINGS_REQUEST_STARTED';
export function welfareFilingsRequestStarted() {
  return {
    type: WELFARE_FILINGS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_FILINGS_REQUEST_ERROR = 'WELFARE_FILINGS_REQUEST_ERROR';
export function welfareFilingsRequestError() {
  return {
    type: WELFARE_FILINGS_REQUEST_ERROR,
  };
}

/**
 * Welfare Filing fetch actions
 */
export const RETIREMENT_FILINGS_FETCHED = 'RETIREMENT_FILINGS_FETCHED';
export function retirementFilingsFetched(retirementFilingsReport) {
  return {
    type: RETIREMENT_FILINGS_FETCHED,
    retirementFilingsReport: retirementFilingsReport,
  };
}
export const RETIREMENT_FILINGS_REQUEST_STARTED = 'RETIREMENT_FILINGS_REQUEST_STARTED';
export function retirementFilingsRequestStarted() {
  return {
    type: RETIREMENT_FILINGS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const RETIREMENT_FILINGS_REQUEST_ERROR = 'RETIREMENT_FILINGS_REQUEST_ERROR';
export function retirementFilingsRequestError() {
  return {
    type: RETIREMENT_FILINGS_REQUEST_ERROR,
  };
}
